var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowSubmitWhite = function SvgArrowSubmitWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 13.807h31.51v3.074H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.422 28.219 14.853-14.853 2.174 2.173-14.854 14.854z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.906.002 33.76 14.855l-2.174 2.174L16.733 2.176z"
  })));
};
export { SvgArrowSubmitWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzUgMzEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3QgeT0iMTMuODA3MSIgd2lkdGg9IjMxLjUwOTciIGhlaWdodD0iMy4wNzQzNCIgZmlsbD0iI2ZmZmZmZiIvPgogIDxyZWN0IHg9IjE3LjQyMTkiIHk9IjI4LjIxOTIiIHdpZHRoPSIyMS4wMDY0IiBoZWlnaHQ9IjMuMDc0MzQiIHRyYW5zZm9ybT0icm90YXRlKC00NSAxNy40MjE5IDI4LjIxOTIpIiBmaWxsPSIjZmZmZmZmIi8+CiAgPHJlY3QgeD0iMTguOTA2MiIgeT0iMC4wMDI0NDE0MSIgd2lkdGg9IjIxLjAwNjQiIGhlaWdodD0iMy4wNzQzNCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTguOTA2MiAwLjAwMjQ0MTQxKSIgZmlsbD0iI2ZmZmZmZiIvPgo8L3N2Zz4K";